import robuxModule from '../robuxModule';

function robuxController($scope, premiumService, premiumConstants, premiumConstantsService) {
  'ngInject';

  $scope.robuxPageData = premiumService.getRobuxPageData();
  $scope.robuxPageData.isUserStatusReady = false;
  $scope.termsLinkStart = `<a href="${premiumService.getTermsPageUrl()}" class="text-link">`;
  $scope.termsLinkEnd = '</a>';
  $scope.showCNBrobuxView = false;
  let allProducts = [];
  const subscriptions = {};
  const robuxForMember = {};
  const robuxForNonMember = {};

  $scope.initPage = function() {
    premiumService
      .getUserStatus()
      .then(
        function(data) {
          initUserPlan(data);
        },
        function() {
          initUserPlan(null);
        }
      )
      .finally(function() {
        $scope.robuxPageData.isUserStatusReady = true;
      });
    premiumService.getAllProducts().then(feedProducts, showError);

    premiumService.getProductPolicy().then(function(data) {
      $scope.showCNBrobuxView = data.includes(premiumConstants.viewCategories.RobuxPackageCNB);
    });
  };
  $scope.initPage();

  function initUserPlan(data) {
    $scope.robuxPageData.userPlan = data ? data.subscriptionProductModel : data;
    $scope.isSubscriber =
      $scope.robuxPageData.userPlan &&
      $scope.robuxPageData.userPlan.hasOwnProperty('subscriptionTypeName');
  }

  function feedProducts(data) {
    if (!data || !data.products) {
      showError({ errorCode: premiumConstants.errorCodes.productsNotFound });
      return;
    }
    allProducts = data.products;
    allProducts.forEach(classifyProducts);
    pairRobuxProduct();
  }

  function showError(error) {
    let errorMessage = '';
    if (error) {
      switch (error.errorCode) {
        case premiumConstants.errorCodes.productsNotFound:
          errorMessage = premiumConstantsService.errorMessages.noData;
          break;
        default:
          errorMessage = premiumConstantsService.errorMessages.general;
      }
    }
    $scope.robuxPageData.errorMessage = errorMessage;
  }

  function classifyProducts(product) {
    const priceKey = product.price.amount.toString();
    if (
      product.subscriptionTypeName === premiumConstants.subscriptions.RobloxPremium450 ||
      product.subscriptionTypeName === premiumConstants.subscriptions.RobloxPremium450OneMonth
    ) {
      $scope.robuxPageData.upsellPackage = product;
    }
    if (product.premiumFeatureTypeName === premiumConstants.premiumFeatureType.subscription) {
      const typeName =
        product.subscriptionTypeName && product.subscriptionTypeName.toString().toLowerCase();

      // User is in app and product is "One Month Roblox Premium"
      const isOneMonthPremiumAndInApp =
        $scope.robuxPageData.isInApp &&
        typeName.indexOf(premiumConstants.premiumFeatureType.month) >= 0;

      // User is Not in app product is "Roblox Premium" (recurring)
      const isRecurringPremiumAndDesktop =
        !$scope.robuxPageData.isInApp &&
        typeName.indexOf(premiumConstants.premiumFeatureType.month) < 0;

      if (isOneMonthPremiumAndInApp || isRecurringPremiumAndDesktop) {
        subscriptions[priceKey] = product;
      }
    } else if (product.isSubscriptionOnly) {
      robuxForMember[priceKey] = product;
    } else {
      robuxForNonMember[priceKey] = product;
    }
  }

  function pairRobuxProduct() {
    // group different products by price
    const robuxPairArray = [];
    for (const priceKey in robuxForNonMember) {
      const robuxPair = {};
      if (robuxForNonMember.hasOwnProperty(priceKey)) {
        robuxPair.normal = robuxForNonMember[priceKey];
      }
      if (robuxForMember.hasOwnProperty(priceKey)) {
        robuxPair.subscriptionOnly = robuxForMember[priceKey];
      }
      if (subscriptions.hasOwnProperty(priceKey)) {
        robuxPair.subscription = subscriptions[priceKey];
      }
      robuxPairArray.push(robuxPair);
    }
    $scope.robuxPageData.robuxs = robuxPairArray.sort((a, b) =>
      a.normal.price.amount > b.normal.price.amount ? 1 : -1
    );
  }
}

robuxModule.controller('robuxController', robuxController);

export default robuxController;
